import React, { useRef } from 'react';
import { BirthdayPicker, IconChevronDown, IconValidationInvalid, InputPanel, KeyboardlessInput, PICKER_WEB_SCROLL_END_DEBOUNCE_MS, } from '@adc/parallax-component-library';
import { DateTimeFormatter, LocalDate } from '@js-joda/core';
import i18n from 'Utilities/i18n';
// initial date is used as date for contents for the input field
const BirthdayInput = ({ initialDate, startDate = LocalDate.now().minusYears(100), endDate = LocalDate.now(), isTouched, errorMessage, error, testID, onDateChange, ...props }) => {
    const currentDateRef = useRef(initialDate ?? LocalDate.now().minusYears(50));
    const handleSelectDate = (date) => {
        currentDateRef.current = date;
    };
    const hasError = isTouched && error;
    return (React.createElement(KeyboardlessInput, { placeholder: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.dob.placeholder'), label: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.dob.label'), "aria-label": i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.dob.label'), value: initialDate ? initialDate.format(DateTimeFormatter.ofPattern('MM/dd/yyyy')) : undefined, error: hasError, supportingIconConfig: hasError ? { icon: React.createElement(IconValidationInvalid, null) } : undefined, supportingText: hasError ? errorMessage : undefined, inlineIconConfig: {
            icon: React.createElement(IconChevronDown, null),
            'aria-label': 'icon',
            color: '$interactive.core.enabled',
            disabledColor: '$interactive.core.disabled',
        }, testID: testID, ...props }, ({ blurInput, hidePanel, inputPanelRef }) => (React.createElement(InputPanel, { ref: inputPanelRef, onDismiss: blurInput, testID: "date-picker", topNavigationProps: {
            title: i18n.t('AccountInformationPersonalInfo.content.accountInformationPersonalInfoForm.formField.dob.label'),
            buttonEnd: {
                element: i18n.t('Global.microcopy.common.done'),
                onPress: () => {
                    setTimeout(() => {
                        hidePanel();
                        onDateChange(currentDateRef.current);
                    }, PICKER_WEB_SCROLL_END_DEBOUNCE_MS + 25);
                },
            },
        } },
        React.createElement(BirthdayPicker, { initialDate: currentDateRef.current, startDate: startDate, endDate: endDate, onDateChange: handleSelectDate })))));
};
export { BirthdayInput };
